<style lang="scss" scoped>
  @import '../../sass/variables';

  #category-menu {
    width: inherit;
    background-color: $white;
    box-shadow: 0 5px 20px rgba(103, 70, 162, 0.18);
    border-bottom-left-radius: 15px;

    h2 {
      color: $gray-dark;
      font-size: 1.125rem;
      font-weight: 500;
      line-height: 30px;
      padding: 25px 30px 20px;
      margin-bottom: 0;
      text-align: center;
      letter-spacing: -0.27px;
    }

    .nav-link {
      color: $gray-dark;
      font-weight: 500;
      line-height: 40px;
      padding: 4px 30px;
      letter-spacing: -0.18px;

      &.active {
        background-color: $white-gray;
      }
    }
  }

  .sticky {
    position: fixed;
    top: 75px;
    right: 0;
  }

  .roundedTopLeft {
    border-top-left-radius: 15px;
  }
</style>

<template>
  <nav
    class="pb-3"
    id="category-menu"
    ref="category-menu"
  >
    <h2 v-once>
      {{ _title }}
    </h2>
    <ul class="nav flex-column">
      <li
        class="nav-item"
        :key="name"
        v-for="(category, name) in categories"
      >
        <a
          class="nav-link"
          href="#"
          :class="{ active: name == current }"
          @click.prevent="toggle(name)"
        >{{ __(category) }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    categories: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: 'Filtre por categoria',
    },
    scrollfix: {
      type: Boolean,
      default: false,
    },
    onTemplate: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  created () {
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  },

  data () {
    return {
      current: 'all',
    };
  },

  computed: {
    _title () {
      return this.__(this.title);
    },
  },

  methods: {
    toggle (event) {
      if (this.current != event) {
        this.current = event;

        this.$emit('update', event);
      }
    },

    handleScroll (evt, el) {
      if (! this.scrollfix) {
        return;
      }

      const menu = document.getElementById('category-menu');
      const header = document.getElementById('the-header');
      const breadcrumb = document.getElementById('bd-breadcrumb');

      if (menu && header && breadcrumb) {
        const sticky = header.scrollHeight + breadcrumb.scrollHeight + 42;

        if (window.scrollY >= sticky) {
          menu.classList.add('sticky');
          menu.classList.add('roundedTopLeft');

          if (this.onTemplate) {
            menu.classList.remove('categories__menu');
          }
        } else {
          menu.classList.remove('sticky');
          menu.classList.remove('roundedTopLeft');

          if (this.onTemplate) {
            menu.classList.add('categories__menu');
          }
        }
      }
    },
  },
};
</script>
